export const PLAYER_TRAIT_FIELDS = [
  { key: "iq", label: "Hockey IQ" },
  { key: "skating", label: "Skating" },
  { key: "skill", label: "Skill" },
  { key: "compete", label: "Compete" },
  { key: "physicality", label: "Physicality" },
];

export const GOALIE_TRAIT_FIELDS = [
  { key: "compete", label: "Compete" },
  { key: "athleticism", label: "Athleticism" },
  { key: "tracking", label: "Tracking" },
  { key: "technique", label: "Technique" },
];

/** @deprecated use traitFieldsForPlayer */
export const RANKING_TRAIT_FIELDS = [
  ...PLAYER_TRAIT_FIELDS,
  ...GOALIE_TRAIT_FIELDS.filter(
    (g) => !PLAYER_TRAIT_FIELDS.some((p) => p.key === g.key)
  ),
];

export const ALL_TRAIT_KEYS = [
  ...new Set([
    ...PLAYER_TRAIT_FIELDS.map(({ key }) => key),
    ...GOALIE_TRAIT_FIELDS.map(({ key }) => key),
  ]),
];

export const TRAIT_SCORE_MIN = 0;
export const TRAIT_SCORE_MAX = 5;

export function isGoalie(playerOrEntry) {
  const pos =
    playerOrEntry?.position ??
    playerOrEntry?.player?.position ??
    playerOrEntry;
  return pos === "G";
}

export function traitFieldsForPlayer(playerOrEntry) {
  return isGoalie(playerOrEntry) ? GOALIE_TRAIT_FIELDS : PLAYER_TRAIT_FIELDS;
}

export const emptyTraitScores = () =>
  Object.fromEntries(ALL_TRAIT_KEYS.map((key) => [key, ""]));
